/* holy-mapped.js — mapped-state UX, keyed by system.
   Two fresh directions, toggle with ?card=c|d (default c). Both overflow-safe
   (flex-wrap, min-width:0, max-width:100%, box-sizing) and free of the icon pair.
     C · the ritual rendered as a real TILE inside the product grid (first row,
         full-width, tinted) — part of shopping, adds zero chrome to the top.
     D · an ultra-minimal single text LINE in the subnav (no thumbs/buttons/icons)
         — the lightest possible mapped state.
   Actions: Add all (primary) · Review (→ guide/results) · Retake. */
(function () {
  var INK = 'rgb(31,27,22)', CREAM = 'rgb(244,239,230)', OCHRE = '#B18B6B', TILE = '#EDE4D3';
  var MODE = ((location.search.match(/[?&]card=([a-d])/i) || [])[1] || 'c').toLowerCase();

  function profileFor(system) {
    if (!system) return null;
    try {
      var raw = localStorage.getItem('mys_profile:' + system);
      if (!raw && system === 'renewal') raw = localStorage.getItem('mys_profile');
      if (!raw) return null;
      var p = JSON.parse(raw);
      return (p && p.t && p.s && p.k) ? p : null;
    } catch (e) { return null; }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(n) { return '$' + (Math.round((+n || 0) * 100) / 100).toFixed(2); }
  function deepLink(base, p) { return !base ? '' : base + (base.indexOf('?') > -1 ? '&' : '?') + 't=' + encodeURIComponent(p.t) + '&s=' + encodeURIComponent(p.s) + '&k=' + encodeURIComponent(p.k); }
  function clearProfile(system) { try { localStorage.removeItem('mys_profile:' + system); if (system === 'renewal') localStorage.removeItem('mys_profile'); } catch (e) {} }
  function thumbURL(u) { if (!u) return ''; return /\/cdn\/shop(ify)?\//.test(u) ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160' : u; }

  var CSS = ''
    + ':root{--mys-ink:' + INK + ';--mys-cream:' + CREAM + ';--mys-ochre:' + OCHRE + ';--mys-soft:rgba(31,27,22,.55);--mys-line:rgba(31,27,22,.12)}'
    /* ---------- shared primary action ---------- */
    + '.mys-add{display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:0 24px;box-sizing:border-box;'
    + 'background:var(--mys-ink);color:var(--mys-cream);border:1px solid var(--mys-ink);border-radius:0;cursor:pointer;'
    + "font:400 11px/1 'Figtree',system-ui,sans-serif;letter-spacing:.16em;text-transform:uppercase;white-space:nowrap;transition:opacity .15s}"
    + '.mys-add:hover{opacity:.86}.mys-add[disabled]{opacity:.5;cursor:default}'
    + ".mys-link{font:500 11px/1 'Figtree',system-ui,sans-serif;letter-spacing:.08em;text-transform:uppercase;color:var(--mys-soft);"
    + 'background:none;border:0;cursor:pointer;padding:12px 0;min-height:44px;display:inline-flex;align-items:center;text-decoration:none;transition:color .15s}'
    + '.mys-link:hover{color:var(--mys-ink)}'
    /* ---------- C · in-grid ritual tile (full-width banner as first grid row) ---------- */
    + '.mys-set{grid-column:1/-1;flex:1 1 100%;display:flex;flex-wrap:wrap;align-items:center;gap:16px 22px;width:100%;max-width:100%;box-sizing:border-box;'
    + "padding:20px 22px;margin:0 0 6px;background:#F2ECE1;border:1px solid var(--mys-line);font-family:'Figtree',system-ui,sans-serif}"
    + '.mys-set *{box-sizing:border-box}'
    + '.mys-set__media{display:flex;gap:8px;flex:0 0 auto}'
    + '.mys-set__t{width:52px;height:66px;background:#fff;border:1px solid var(--mys-line);overflow:hidden;flex:0 0 auto}'
    + '.mys-set__t img{width:100%;height:100%;object-fit:contain;display:block}'
    + '.mys-set__t.is-empty{background:repeating-linear-gradient(135deg,#efe7d8,#efe7d8 3px,#e7ddc9 3px,#e7ddc9 6px)}'
    + '.mys-set__tx{display:flex;flex-direction:column;gap:5px;min-width:0;flex:1 1 220px}'
    + '.mys-set__k{font:500 9px/1;letter-spacing:.16em;text-transform:uppercase;color:var(--mys-ochre)}'
    + ".mys-set__name{font:500 22px/1 'EB Garamond',Georgia,serif;color:var(--mys-ink)}"
    + '.mys-set__meta{font:400 13px/1;color:var(--mys-soft)}'
    + '.mys-set__cta{display:flex;flex-wrap:wrap;align-items:center;gap:8px 18px;flex:0 0 auto}'
    /* ---------- D · minimal text line ---------- */
    + '.mys-line{display:flex;flex-wrap:wrap;align-items:baseline;gap:4px 12px;width:100%;max-width:100%;'
    + "font-family:'Figtree',system-ui,sans-serif;color:var(--mys-soft)}"
    + '.mys-line *{box-sizing:border-box}'
    + '.mys-line__tick{color:var(--mys-ochre)}'
    + ".mys-line__name{font:500 15px/1.1 'EB Garamond',Georgia,serif;color:var(--mys-ink)}"
    + '.mys-line__meta{font:400 12px/1.1;color:var(--mys-soft)}'
    + '.mys-line__acts{display:flex;flex-wrap:wrap;align-items:center;gap:2px 16px;margin-left:auto}'
    + '.mys-line__acts .mys-link{padding:8px 0;min-height:36px}'
    + '.mys-line__acts .is-primary{color:var(--mys-ink);border-bottom:1px solid var(--mys-ink)}'
    /* subnav slot: full width on mobile; mode C empties it */
    + '.subnav__chipslot{flex:1 1 100%!important;width:100%;max-width:100%;margin-left:0!important;margin-top:12px;padding-top:12px;border-top:1px solid rgba(31,27,22,.1);box-sizing:border-box}'
    + '.subnav__chipslot.is-empty{display:none!important}'
    /* ---------- desktop ---------- */
    + '@media(min-width:1025px){'
    + '.subnav__chipslot{flex:0 1 auto!important;width:auto;max-width:60%;margin-left:auto!important;margin-top:0;padding-top:0;border-top:0}'
    + '.mys-line__acts{gap:2px 18px}'
    + '.mys-set__name{font-size:24px}'
    + '}';
  var cssDone = false;
  function injectCSS() { if (cssDone) return; cssDone = true; var s = document.createElement('style'); s.textContent = CSS; document.head.appendChild(s); }

  function addToCart(items, cell, btn) {
    var lines = (items || []).filter(function (it) { return it.v; }).map(function (it) { return { id: Number(it.v) || it.v, quantity: 1, properties: { '_skin_profile': cell || '' } }; });
    if (!lines.length) { window.location.href = '/cart'; return; }
    if (btn) { btn.disabled = true; btn.dataset.busy = btn.textContent; btn.textContent = 'Adding…'; }
    var R = window.routes || {};
    fetch(R.cart_add_url || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: lines }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { window.location.href = R.cart_url || '/cart'; })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.busy || 'Add all'; } window.location.href = R.cart_url || '/cart'; });
  }
  function bindActions(scope, items, prof, flow, href) {
    var add = scope.querySelector('[data-mys-add]'); if (add) add.addEventListener('click', function () { addToCart(items, prof.cell, this); });
    var rt = scope.querySelector('[data-mys-retake]'); if (rt) rt.addEventListener('click', function () { clearProfile(prof.system || 'renewal'); window.location.href = flow || '/pages/map-your-skin'; });
  }

  function findGrid() {
    var prod = document.querySelector('a[href*="/products/"]'); if (!prod) return null;
    var item = prod;
    for (var i = 0; i < 7 && item.parentElement; i++) {
      var p = item.parentElement;
      var kids = [].slice.call(p.children).filter(function (c) { return c.querySelector && c.querySelector('a[href*="/products/"]'); });
      if (kids.length >= 2) return p;
      item = p;
    }
    return null;
  }

  /* C — ritual tile as the first row of the product grid */
  function renderSet(slot, prof, href, flow) {
    injectCSS();
    var grid = findGrid(); if (!grid) { renderLine(slot, prof, href, flow); return; } /* fallback if no grid */
    document.querySelectorAll('.mys-set').forEach(function (n) { n.remove(); }); /* idempotent — never double the band */
    var items = prof.items || [], count = items.length, total = items.reduce(function (a, it) { return a + (parseFloat(it.p) || 0); }, 0);
    var media = items.slice(0, 3).map(function (it) {
      var img = it.img ? '<img src="' + esc(thumbURL(it.img)) + '" alt="' + esc(it.t || '') + '" decoding="async" onerror="this.remove();this.parentNode.classList.add(&quot;is-empty&quot;)">' : '';
      return '<span class="mys-set__t' + (it.img ? '' : ' is-empty') + '">' + img + '</span>';
    }).join('');
    var el = document.createElement('div');
    el.className = 'mys-set';
    el.innerHTML =
      '<span class="mys-set__media">' + media + '</span>'
      + '<span class="mys-set__tx"><span class="mys-set__k">Your ritual</span>'
      + '<span class="mys-set__name">' + esc(prof.cell || 'Your ritual') + '</span>'
      + '<span class="mys-set__meta">' + (count ? count + ' step' + (count === 1 ? '' : 's') + ' &middot; ' : '') + money(total) + '</span></span>'
      + '<span class="mys-set__cta">'
      + '<button type="button" class="mys-add" data-mys-add>Add all</button>'
      + '<a class="mys-link" href="' + esc(href || flow || '#') + '">Review</a>'
      + '<button type="button" class="mys-link" data-mys-retake>Retake</button>'
      + '</span>';
    var cells = [].slice.call(grid.children), fpc = null;
    for (var ci = 0; ci < cells.length; ci++) { if (cells[ci].querySelector && cells[ci].querySelector('a[href*="/products/"]')) { fpc = cells[ci]; break; } }
    grid.insertBefore(el, fpc || grid.firstChild);
    slot.classList.add('is-empty'); slot.hidden = true;
    bindActions(el, items, prof, flow, href);
  }

  /* D — minimal text line */
  function renderLine(slot, prof, href, flow) {
    injectCSS();
    var items = prof.items || [], count = items.length, total = items.reduce(function (a, it) { return a + (parseFloat(it.p) || 0); }, 0);
    slot.innerHTML =
      '<span class="mys-line">'
      + '<span class="mys-line__tick">&#10003;</span> '
      + '<span class="mys-line__name">' + esc(prof.cell || 'Your ritual') + '</span>'
      + '<span class="mys-line__meta">' + (count ? count + ' step' + (count === 1 ? '' : 's') + ' &middot; ' : '') + money(total) + '</span>'
      + '<span class="mys-line__acts">'
      + '<a class="mys-link" href="' + esc(href || flow || '#') + '">Review</a>'
      + '<button type="button" class="mys-link" data-mys-retake>Retake</button>'
      + '<button type="button" class="mys-link is-primary" data-mys-add>Add all</button>'
      + '</span></span>';
    slot.hidden = false;
    bindActions(slot, items, prof, flow, href);
  }

  function fillPill(slot, label, cell, href) {
    var text = esc(label) + (cell ? ' &middot; ' + esc(cell) : '');
    slot.innerHTML = href ? '<a class="hc-chip" href="' + esc(href) + '">' + text + ' &rarr;</a>' : '<span class="hc-chip">' + text + '</span>';
    slot.hidden = false;
  }

  function wire(root) {
    var system = root.getAttribute('data-mapped-system');
    var prof = profileFor(system);
    if (!prof) return;
    root.classList.add('is-mapped');
    var flow = root.getAttribute('data-mapped-flow') || '';
    var href = deepLink(flow, prof);
    var cell = prof.cell || '';
    var hasSnap = !!(prof.items && prof.items.length);

    root.querySelectorAll('[data-mapped-chip]').forEach(function (slot) {
      if (!hasSnap) { fillPill(slot, slot.getAttribute('data-label') || 'Your Profile', cell, href); return; }
      if (MODE === 'd') renderLine(slot, prof, href, flow);
      else renderSet(slot, prof, href, flow);
    });
    root.querySelectorAll('[data-mapped-line]').forEach(function (el) { el.textContent = el.textContent.replace('{cell}', cell); });
    root.querySelectorAll('[data-mapped-link]').forEach(function (a) { if (href) a.setAttribute('href', href); });
    root.querySelectorAll('[data-mapped-hide]').forEach(function (el) { el.hidden = true; });
    if (!hasSnap) root.querySelectorAll('[data-mapped-show]').forEach(function (el) { el.hidden = false; });
  }

  function boot() { document.querySelectorAll('[data-mapped-system]').forEach(wire); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
